import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { trigger, transition, style, animate } from '@angular/animations';
import { PontuacaoGanhaResponse } from 'app/shared/models/ei-models';

@Component({
  selector: 'app-pontos-toast',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  template: `
    <div class="pontos-toast" [@slideIn]>
      <div class="toast-icon">
        <div class="icon-circle">
          <mat-icon>stars</mat-icon>
        </div>
        <div class="sparkles">
          <span class="sparkle">✨</span>
          <span class="sparkle">✨</span>
        </div>
      </div>
      
      <div class="toast-content">
        <div class="toast-header">
          <span class="pontos-ganhos">+{{ pontosAnimados }} pontos</span>
          <span class="emoji">🎉</span>
        </div>
        <p class="toast-message">{{ data.mensagem }}</p>
        <div class="toast-footer">
          <span class="total">
            <mat-icon>trending_up</mat-icon>
            Total: {{ data.pontuacaoTotal | number }} pts
          </span>
          <span class="ranking" *ngIf="data.posicaoRanking">
            <mat-icon>emoji_events</mat-icon>
            {{ data.posicaoRanking }}º lugar
          </span>
        </div>
      </div>
      
      <button class="toast-close" (click)="fechar()">
        <mat-icon>close</mat-icon>
      </button>
      
      <div class="toast-progress">
        <div class="progress-bar" [style.animation-duration.ms]="duracaoMs"></div>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }
    
    .pontos-toast {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
      border: 1px solid rgba(228, 129, 30, 0.3);
      border-radius: 12px;
      padding: 16px;
      min-width: 320px;
      max-width: 400px;
      position: relative;
      overflow: hidden;
      box-shadow: 
        0 8px 32px rgba(0, 0, 0, 0.4),
        0 0 20px rgba(228, 129, 30, 0.1);
    }
    
    .toast-icon {
      position: relative;
      flex-shrink: 0;
    }
    
    .icon-circle {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: linear-gradient(135deg, #E4811E, #f59e0b);
      display: flex;
      align-items: center;
      justify-content: center;
      animation: pulse-glow 2s ease-in-out infinite;
      
      mat-icon {
        color: white;
        font-size: 24px;
        width: 24px;
        height: 24px;
      }
    }
    
    .sparkles {
      position: absolute;
      top: -5px;
      right: -5px;
      
      .sparkle {
        position: absolute;
        font-size: 12px;
        animation: sparkle 1.5s ease-in-out infinite;
        
        &:nth-child(1) {
          top: 0;
          right: 0;
          animation-delay: 0s;
        }
        
        &:nth-child(2) {
          top: 8px;
          right: -8px;
          animation-delay: 0.5s;
        }
      }
    }
    
    @keyframes sparkle {
      0%, 100% { opacity: 0; transform: scale(0.5); }
      50% { opacity: 1; transform: scale(1); }
    }
    
    @keyframes pulse-glow {
      0%, 100% { box-shadow: 0 0 10px rgba(228, 129, 30, 0.3); }
      50% { box-shadow: 0 0 20px rgba(228, 129, 30, 0.6); }
    }
    
    .toast-content {
      flex: 1;
      min-width: 0;
    }
    
    .toast-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 4px;
    }
    
    .pontos-ganhos {
      font-size: 18px;
      font-weight: 700;
      background: linear-gradient(90deg, #E4811E, #f59e0b);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
    
    .emoji {
      font-size: 16px;
      animation: bounce 1s ease-in-out infinite;
    }
    
    @keyframes bounce {
      0%, 100% { transform: translateY(0); }
      50% { transform: translateY(-3px); }
    }
    
    .toast-message {
      margin: 0 0 8px 0;
      font-size: 13px;
      color: rgba(255, 255, 255, 0.85);
      line-height: 1.4;
    }
    
    .toast-footer {
      display: flex;
      align-items: center;
      gap: 16px;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.6);
      
      span {
        display: flex;
        align-items: center;
        gap: 4px;
        
        mat-icon {
          font-size: 14px;
          width: 14px;
          height: 14px;
        }
      }
      
      .total mat-icon {
        color: #4ade80;
      }
      
      .ranking mat-icon {
        color: #fbbf24;
      }
    }
    
    .toast-close {
      position: absolute;
      top: 8px;
      right: 8px;
      background: transparent;
      border: none;
      padding: 4px;
      cursor: pointer;
      color: rgba(255, 255, 255, 0.4);
      border-radius: 4px;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      
      &:hover {
        color: rgba(255, 255, 255, 0.8);
        background: rgba(255, 255, 255, 0.1);
      }
      
      mat-icon {
        font-size: 18px;
        width: 18px;
        height: 18px;
      }
    }
    
    .toast-progress {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: rgba(255, 255, 255, 0.1);
      overflow: hidden;
    }
    
    .progress-bar {
      height: 100%;
      background: linear-gradient(90deg, #E4811E, #f59e0b);
      animation: progress linear forwards;
      transform-origin: left;
    }
    
    @keyframes progress {
      from { transform: scaleX(1); }
      to { transform: scaleX(0); }
    }
  `],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(100%)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateX(100%)' }))
      ])
    ])
  ]
})
export class PontosToastComponent implements OnInit, OnDestroy {
  pontosAnimados = 0;
  duracaoMs = 10000; // 10 segundos
  private timer: any;
  
  constructor(
    public snackBarRef: MatSnackBarRef<PontosToastComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: PontuacaoGanhaResponse
  ) {}
  
  ngOnInit(): void {
    this.animarPontos();
  }
  
  ngOnDestroy(): void {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
  
  private animarPontos(): void {
    const duracao = 600;
    const intervalo = 30;
    const passos = duracao / intervalo;
    const incremento = this.data.pontos / passos;
    let atual = 0;
    
    this.timer = setInterval(() => {
      atual += incremento;
      if (atual >= this.data.pontos) {
        this.pontosAnimados = this.data.pontos;
        clearInterval(this.timer);
      } else {
        this.pontosAnimados = Math.floor(atual);
      }
    }, intervalo);
  }
  
  fechar(): void {
    this.snackBarRef.dismiss();
  }
}
